document.addEventListener("DOMContentLoaded", function() {
  var SUPPRESS_KEY = 'fd_popup_suppress_until';
  var now = Date.now();

  // Helpers
  function setSuppressForOneDay() {
    var oneDayMs = 24 * 60 * 60 * 1000;
    var until = String(now + oneDayMs);
    try {
      localStorage.setItem(SUPPRESS_KEY, until);
    } catch (e) {}
    try {
      // Cookie fallback, 1 day
      var d = new Date();
      d.setTime(d.getTime() + oneDayMs);
      document.cookie = SUPPRESS_KEY + "=" + until + ";expires=" + d.toUTCString() + ";path=/";
    } catch (e) {}
  }

  function getSuppressUntil() {
    var v = null;
    try { v = localStorage.getItem(SUPPRESS_KEY); } catch (e) {}
    if (!v) {
      // Cookie fallback
      var match = document.cookie.match(new RegExp('(^| )' + SUPPRESS_KEY + '=([^;]+)'));
      if (match) v = match[2];
    }
    var num = parseInt(v || '0', 10);
    return isNaN(num) ? 0 : num;
  }

  // Respect suppression before doing anything
  if (now < getSuppressUntil()) return;

  // Avoid duplicate injection if HTML already exists
  if (document.getElementById('fathersday-popup-overlay')) return;

  // Inject popup HTML
  document.body.insertAdjacentHTML('beforeend', `
    <div id="fathersday-popup-overlay">
      <div id="fathersday-popup">
        <button id="fathersday-popup-close" aria-label="Close popup">&times;</button>
        <h2>FATHER'S DAY</h2>
        <p>This Father’s Day, gift your loved one the luxury they deserve.</p>
        <p>For personalised gifting, and delivery timeframes please contact K'DOR Concierge</p>
        <a id="popup-livechat-link" class="chat-button" href="#">Explore</a>
      </div>
    </div>
  `);

  var overlay = document.getElementById('fathersday-popup-overlay');
  var popup = document.getElementById('fathersday-popup');
  var closeBtn = document.getElementById('fathersday-popup-close');
  var exploreBtn = document.getElementById('popup-livechat-link');

  // Build chat link with ?chat
  var currentUrl = window.location.href;
  var chatUrl = currentUrl.includes('?') ? currentUrl + '&chat' : currentUrl + '?chat';
  exploreBtn.setAttribute('href', chatUrl);

  // Show popup after 3 seconds
  setTimeout(function() {
    overlay.classList.add('show');
    setTimeout(function() { popup.classList.add('show'); }, 50);
  }, 3000);

  function hideAndSuppress() {
    overlay.classList.remove('show');
    popup.classList.remove('show');
    setSuppressForOneDay();
  }

  // Close interactions
  closeBtn.addEventListener('click', hideAndSuppress);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) hideAndSuppress();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') hideAndSuppress();
  });

  // Suppress if they click Explore as well
  exploreBtn.addEventListener('click', function() {
    setSuppressForOneDay();
  });
});
